import { render, staticRenderFns } from "./shopIndex.vue?vue&type=template&id=38abff30&scoped=true&"
import script from "./shopIndex.vue?vue&type=script&lang=js&"
export * from "./shopIndex.vue?vue&type=script&lang=js&"
import style0 from "./shopIndex.vue?vue&type=style&index=0&id=38abff30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38abff30",
  null
  
)

export default component.exports